
import React, { useEffect } from 'react';

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";

export default () => {

  useEffect(() => {
    document.title = "Kỳ quay Mega 6/45"
  }, []);

  return (
    <>
      <FilterForm />
      <br />
      <Table />
    </>
  );
};
